// src/components/SecuredImage.tsx
import { Box, SxProps, Theme } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface SecuredImageProps {
  headerKey?: Record<string, string>;
  src: string;
  alt: string;
  width: string;
  height: string;
  sx?: SxProps<Theme>;
}

const SecuredImage: React.FC<SecuredImageProps> = ({
  headerKey,
  src,
  alt = '',
  width,
  height,
  sx,
}) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!src) return;

    let objectUrl: string | null = null;

    const fetchImage = async () => {
      try {
        const response = await fetch(
          `${
            localStorage.getItem('url') ?? process.env.REACT_APP_PRIVATE_ID_API
          }${src}`,
          {
            headers: {
              'X-App-Id': headerKey?.appId ?? '',
              'X-App-Key': headerKey?.appKey ?? '',
              'X-App-Db': headerKey?.dbId ?? '',
              'X-App-Db-Key': headerKey?.dbKey ?? '',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.status}`);
        }

        const imageBlob = await response.blob();
        objectUrl = URL.createObjectURL(imageBlob);
        setImageUrl(objectUrl);
      } catch (err: unknown) {
        // empty
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  return (
    <Box
      sx={{
        width: width,
        height: height,
        border: '1px solid #bababa',
        backgroundColor: '#fff',
        ...sx,
      }}
    >
      <Box
        component='img'
        src={imageUrl ?? ''}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
        alt={alt}
      />
    </Box>
  );
};

export default SecuredImage;
